import React from "react";
import styles from "../DressingChangeFrequency.module.scss";
import { MODES } from "../utils/scheduleUtils";
import type { ScheduleMode } from "../types";

const ModeIcon: React.FC<{ d: string }> = ({ d }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    className={styles.mode_icon}
  >
    <path d={d} />
  </svg>
);

interface ModeSelectorProps {
  mode: ScheduleMode;
  onChange: (patch: { mode: ScheduleMode }) => void;
}

export const ModeSelector: React.FC<ModeSelectorProps> = ({ mode, onChange }) => (
  <div className={styles.panel_row}>
    <span className={styles.panel_label}>Schedule type</span>
    <div role="group" aria-label="Schedule type" className={styles.mode_group}>
      {MODES.map((m) => {
        const on = mode === m.id;
        return (
          <button
            key={m.id}
            type="button"
            className={`${styles.mode_btn} ${on ? styles.mode_btn_on : ""}`}
            aria-pressed={on}
            onClick={() => onChange({ mode: m.id })}
          >
            <ModeIcon d={m.icon} />
            <span>{m.label}</span>
          </button>
        );
      })}
    </div>
  </div>
);
